<template>
  <div class="bg-gray-900 text-white p-4 text-sm flex justify-between gap-2 z-10">
    <div class="flex items-center">
      <a href="https://vrify.com" class="text-white hover_text-white" target="blank" title="powered by VRIFY">
        <MarkLogo class="h-6 sm_hidden" />
        <VrifyLogo class="h-5 mr-6 hidden sm_block my-auto" />
      </a>
    </div>

    <slot />

    <slot name="close">
      <button class="bg-transparent text-white self-start align-center focus:outline-none" type="button" @click="$emit('close')">
        <span class="sr-only">Close</span>
        <XIcon class="w-6" />
      </button>
    </slot>
  </div>
</template>

<script lang="ts" setup>
import XIcon from '@/components/icons/x.svg'
import MarkLogo from '@/assets/images/mark-logo.svg'
import VrifyLogo from '@/assets/images/vrify-logo.svg'

defineEmits(['close'])
</script>
